<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
      <div class="col-md-9 ps-5">
        <h2 class="col pb-2 title">
          {{ "REALTIMEALARMS" | translate }}
        </h2>
        <h6 class="col subtitle">{{ "EVENTS&ALARMS_SUBTITLE" | translate }}</h6>
      </div>
      <div class="col-md-3 d-flex justify-content-end align-items-center pe-5">
        <div class="position-relative">
          <div class="settings-button ps-3 pe-3 pb-2 pt-1" (click)="toggleSelectOption()">
            <img alt="Settings" src="assets/core/table-button/filter.svg" />
          </div>
          <div class="select-option-overlay" *ngIf="isSelectOptionOpen" (click)="closeSelectOption()"></div>
          <div class="select-option-modal" *ngIf="isSelectOptionOpen">
            <div class="select-option-header">
              <span>{{ "SELECT_OPTION" | translate }}</span>
              <img alt="Close" src="assets/device/x.svg" (click)="closeSelectOption()" class="close-icon" />
            </div>
            <div class="select-option-item" (click)="selectAlarmTab('all-events')">
              <span>{{ "ALLALARMS" | translate }}</span>
              <input type="radio" [checked]="selectedAlarmTab === 'all-events'" readonly />
            </div>
            <div class="select-option-item" (click)="selectAlarmTab('raw-events')">
              <span>{{ "RAW_ALARMS" | translate }}</span>
              <input type="radio" [checked]="selectedAlarmTab === 'raw-events'" readonly />
            </div>
            <div class="select-option-footer">
              <button class="apply-btn" (click)="applyAlarmTab()">{{ "APPLY" | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (activeTab === 'raw-events') {
    <app-raw-alarms></app-raw-alarms>
    } @else if (activeTab === 'all-events') {
    <app-individual-alarms></app-individual-alarms>
    }
  </div>
</div>
